// payments views
import Tools from '@/views/Tools.vue';

import LandingLeagues from '@/views/Tools/LandingLeagues.vue';
import LeagueMatches from '@/views/Tools/LeagueMatches.vue';
import MarketingMaterials from '@/views/Tools/MarketingMaterials.vue';
import DnsHostingAccounts from '@/views/Tools/DnsHostingAccounts.vue';
import DedicatedSiteDomains from '@/views/Tools/DedicatedSiteDomains.vue';
import DomainRegistrarAccounts from '@/views/Tools/DomainRegistrarAccounts.vue';
import PlatformServers from '@/views/Tools/PlatformServers.vue';
import RotationGroups from '@/views/Tools/RotationGroups.vue';
import ServiceDomains from '@/views/Tools/ServiceDomains.vue';

export default [
  {
    path: '/tools',
    component: Tools,
    meta: {
      requiresAuth: true,
      view: 'tools',
    },
    children: [
      {
        path: 'landing-leagues',
        component: LandingLeagues,
        name: 'tools.landing-leagues',
        meta: {
          view: 'landingLeagues',
        },
      },
      {
        path: 'league/:id/matches',
        component: LeagueMatches,
        name: 'tools.league-matches',
        meta: {
          view: 'leagueMatches',
        },
      },
      {
        path: 'dns-hosting-accounts',
        component: DnsHostingAccounts,
        name: 'tools.dns_hosting_accounts',
        meta: {
          view: 'dns_hosting_accounts',
          permission: {
            list: ['dns_hosting_accounts_view'],
          },
        },
      },
      {
        path: 'domain-registrar-accounts',
        component: DomainRegistrarAccounts,
        name: 'tools.domain_registrar_accounts',
        meta: {
          view: 'domain_registrar_accounts',
          permission: {
            list: ['domain_registrar_accounts_view'],
          },
        },
      },
      {
        path: 'dedicated-site-domains',
        component: DedicatedSiteDomains,
        name: 'tools.dedicated_site_domains',
        meta: {
          view: 'dedicated_site_domains',
          permission: {
            list: ['platform_betting_domains_view'],
          },
        },
      },
      {
        path: 'servers',
        component: PlatformServers,
        name: 'tools.platform_servers',
        meta: {
          view: 'platform_servers',
          permission: {
            list: ['platform_servers_view'],
          },
        },
      },
      {
        path: 'rotation-groups',
        component: RotationGroups,
        name: 'tools.rotation_groups',
        meta: {
          view: 'rotation_groups',
          permission: {
            list: ['service_rotation_groups_view'],
          },
        },
      },
      {
        path: 'service-domains',
        component: ServiceDomains,
        name: 'tools.service_domains',
        meta: {
          view: 'service_domains',
          permission: {
            list: ['platform_service_domains_view'],
          },
        },
      },
      {
        path: 'marketing-materials',
        component: MarketingMaterials,
        name: 'tools.marketing-materials',
        meta: {
          view: 'marketing-materials',
          permission: {
            list: ['marketing_materials_view'],
          },
        },
      },
      {
        path: '',
        name: 'tools.empty',
        redirect: {
          name: 'tools.rotation_groups',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'tools.catch-all',
        redirect: {
          name: 'tools.rotation_groups',
        },
      },
    ],
  },
];
